import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../dave-data-module/State';
import { AppGatewayService } from '../dave-data-module/services/app-gateway.service';
import { ImageResizeRequest, ImageResizeResponse, PdfToImageRequest, PdfToImageResponse } from '@dave/types';
import { BaseActionTypes } from '../dave-data-module/State/actions/base.actions';

enum ErrorCodes {
  Resize = 'Bild skalieren fehlgeschlagen',
  Convert = ' PDF zu Bild konvertieren fehlgeschlagen'
}
@Injectable({
    providedIn: 'root',
})
export class PdfToolsService {
    constructor(
      private store: Store<State>, 
      private gatewayService: AppGatewayService,
    ) {}

    convertPDFToImage(Payload: PdfToImageRequest): Promise<PdfToImageResponse> {
      return this.gatewayService.Request({PdfToolsPdfToImage: Payload})
          .then((res) => {
              if(Object.keys(res?.Errors || {}).length === 0) {
                  return res.PdfToolsPdfToImage
              }  else {
                  throw res.Errors
              }
          })
          .catch((err) => {
              this.store.dispatch(
                  BaseActionTypes.ErrorAction({
                      Payload: {
                          ToasterMessage: ErrorCodes.Convert,
                          Err: err,
                      },
                  }),
              );
            return null
        });
    }

    resizeImage(Payload: ImageResizeRequest): Promise<ImageResizeResponse> {
        return this.gatewayService.Request({ImageToolsImageResize: Payload})
            .then((res) => {
                if(Object.keys(res?.Errors || {}).length === 0) {
                  return res.ImageToolsImageResize
                } else {
                  throw res.Errors
                }
            })
            .catch((err) => {
                this.store.dispatch(
                    BaseActionTypes.ErrorAction({
                        Payload: {
                            ToasterMessage: ErrorCodes.Resize,
                            Err: err,
                        },
                    }),
                );
            return null
        });
    }
}
